// Version courante des conditions d'utilisation (format YYYY-MM-DD, date de
// publication). Un bump ⇒ toutes les acceptations antérieures deviennent
// obsolètes : le gate ProtectedRoute se représente à tous les comptes (voir
// terms_acceptances, unique (user_id, version) — l'historique des versions
// déjà acceptées reste conservé).
export const TERMS_VERSION = "2026-07-22";
